<template>
  <FlagPickerField
    :value="value"
    :items="currencies"
    :loading="loading"
    :select-placeholder="selectPlaceholder"
    :search-placeholder="searchPlaceholder"
    :search-label="searchLabel"
    empty-message="No currencies available"
    :format-label="formatCurrencyLabel"
    @input="$emit('input', $event)"
    @search="$emit('search', $event)"
    @clear="$emit('clear')"
  />
</template>

<script setup>
import FlagPickerField from "@components/FlagPickerField/FlagPickerField.vue";

defineProps({
  value: { type: Object, default: null },
  currencies: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  selectPlaceholder: { type: String, default: "Select Currency" },
  searchPlaceholder: { type: String, default: "Type to search." },
  searchLabel: { type: String, default: "Search Currency" },
});

defineEmits(["input", "search", "clear"]);

function formatCurrencyLabel(item) {
  if (!item) return "";
  const name = item.name || "";
  const code = item.code || "";
  if (name && code) return `${name} (${code})`;
  return name || code;
}
</script>
